
// Namespacing

window.site = (window.site || {});


// ScrollTo - opened / close

site.ScrollTo = (function ScrollTo($) {

  'use strict';

  /**
   * Has the class been initialized?
   * @private
   */
  var inited = false;

    /**
     * Initializes the class.
     * @public
     */
    var init = function() {

      // Abort if already initialized
      if (inited) {
        return false;
      }

      inited = true;

      // Initiate ScrollTo
      initScroll();

      return true;

    };

    // ------------------------------------
    // EVENT HANDLERS
    // ------------------------------------

    var initScroll = function() {

        $( '[data-goto]' ).on( 'click', function(){

            var nextSection = $( this ).attr( 'data-goto' );

            $( 'html, body' ).animate({
                scrollTop: $( '#'+nextSection ).offset().top - 90
            }, 855);

        });
    };

    return {
      init: init
    };


}.bind(site, jQuery)());

